import React from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { ADYEN_RESULT_CODE } from "../../apis/useSubmitPayment/types";
import OrderContainer from "./OrderContainer/OrderContainer";
import OrderFail from "./OrderFail/OrderFail";

const OrderConfirmation: React.FC = () => {
	const { t } = useTranslation();
	const [searchParams] = useSearchParams();

	// Check for 3DS payment failure
	const resultCode = searchParams.get("resultCode");
	const isPaymentFailure = resultCode === ADYEN_RESULT_CODE.REFUSED;

	// Payment failure has highest priority
	if (isPaymentFailure) {
		return <OrderFail errorMessage={t("paymentPage.error.cardRefused")} />;
	}

	// Normal order flow - let OrderContainer handle loading/error states and layout selection
	return <OrderContainer />;
};

export default OrderConfirmation;
